export enum AccountIdentifierType {
  BankAccount,
  PolicyNumber
}
